import { Injectable } from '@angular/core';

import { Menu, MenuBase, MenuIcon } from '@camelot/menu';
import { MissionType } from '@camelot/user';

@Injectable({
  providedIn: 'root',
})
export class CamPlanningMenuService {
  public getMissionTypeNavMenu(callback: ((data?: any) => void) | undefined): Menu {
    const menu: MenuBase[] = [
      new MenuIcon({
        key: 'sales',
        label: 'project.tasks.task-state.context.menu.sales',
        order: 1,
        defaultOpen: true,
        callback: () => callback?.(MissionType.Sales),
      }),
      new MenuIcon({
        key: 'technical',
        label: 'project.tasks.task-state.context.menu.technical',
        order: 2,
        callback: () => callback?.(MissionType.Technical),
      }),
      new MenuIcon({
        key: 'installation',
        label: 'project.tasks.task-state.context.menu.installation',
        order: 3,
        callback: () => callback?.(MissionType.Installation),
      }),
      new MenuIcon({
        key: 'inspection',
        label: 'project.tasks.task-state.context.menu.inspection',
        order: 4,
        callback: () => callback?.(MissionType.Inspection),
      }),
      new MenuIcon({
        key: 'customer-support',
        label: 'project.tasks.task-state.context.menu.customer-support',
        order: 5,
        callback: () => callback?.(MissionType.CustomerSupport),
      }),
      new MenuIcon({
        key: 'maintenance',
        label: 'project.tasks.task-state.context.menu.maintenance',
        order: 6,
        callback: () => callback?.(MissionType.Maintenance),
      }),
      new MenuIcon({
        key: 'project-management',
        label: 'project.tasks.task-state.context.menu.project-management',
        order: 7,
        callback: () => callback?.(MissionType.ProjectManagement),
      }),
      new MenuIcon({
        key: 'other',
        label: 'project.tasks.task-state.context.menu.other',
        order: 8,
        callback: () => callback?.(MissionType.Other),
      }),
    ];
    return new Menu({
      elements: menu.sort((a, b) => a.order - b.order),
      direction: 'horizontal',
    });
  }
}
